import { faCreditCard } from '@fortawesome/free-solid-svg-icons'

import { TrustedSourceCard } from '@/components/IncomeCard/TrustedSources/TrustedSourceCard'
import { getPayrollOptOutReasonText } from '@/components/IncomeCard/utils'
import type { KonfirIntegration } from '@/types/Activity'

import KonfirOutcome from './KonfirOutcome'
import KonfirSignInButton from './KonfirSignInButton'

const FAQS = [
  {
    question: 'Why is a 2-month Konfir connection different from 3 months or more?',
    answer:
      'If an applicant has been employed for 2 months then you might see 1 or 2 income payments in the Konfir report. This is not the case for 3-month connections. This means you have to be more careful when checking these connections',
  },
  {
    question:
      'Do I need to chase for an employment contract if I have a Konfir connection for 2 months employed?',
    answer:
      "No, you don't need to chase for employment contract. You can verify the income based on Konfir.",
  },
]

const GUIDE_ME_INTRO = (
  <>
    Here&apos;s how to assess an applicant who has provided a Konfir connection for an
    employment that is 2-3 months.
    <p>
      We will assess based on Gross Income (tax year to date) or base salary figure (if
      present).
    </p>
  </>
)

export interface Props {
  integration: KonfirIntegration
  isShortEmployment: boolean
}

const KonfirPayroll: React.FC<Props> = ({ integration, isShortEmployment }) => {
  const isConnected = integration.status === 'Connected'
  const outcome = integration.outcome
  const optOutReason = integration.optOutReason

  return (
    <TrustedSourceCard
      icon={faCreditCard}
      title="Payroll"
      isConnected={isConnected}
      isShortEmployment={isShortEmployment}
      guideMe={{
        sidebarTitle: 'Konfir Guide Me',
        intro: GUIDE_ME_INTRO,
        faqs: FAQS,
        bannerCopy: "Note: This applicant's current employment is between 2-3 months.",
      }}
      statusMessage={
        isConnected
          ? 'This applicant was successfully connected to Konfir.'
          : 'The applicant was eligible for payroll but did not connect their bank account.'
      }
      hasOutcome={!!outcome}
      comments={outcome?.reasons}
      optOutReason={optOutReason}
      getOptOutReasonText={getPayrollOptOutReasonText}
      outcomeContent={outcome && <KonfirOutcome outcome={outcome} />}
      actionLink={<KonfirSignInButton />}
    />
  )
}

export default KonfirPayroll
